import { useSnackbar } from 'notistack';

// core
import { Polling } from '_core/polling';


export { Polling };

export const useRequest = () => {
  const { enqueueSnackbar } = useSnackbar();

  const onFailure = (error) => {
    process.env.NODE_ENV !== 'production' && console.error(error);
    
    enqueueSnackbar(error.message, { variant: 'error' });
  };

  return {
    send: Polling.send,
    queue: Polling.queue,
    sendAndDo: options => Polling.sendAndDo({ onFailure, ...options }),
    queueAndDo: options => Polling.queueAndDo({ onFailure, ...options }),
    doNotice: Polling.doNotice,
    onNotice: Polling.onNotice,
    useNotice: Polling.useNotice,
    onFailure
  };
};
